import { Helmet } from 'react-helmet-async'
import { absoluteUrl } from '@/lib/url'
import { siteConfig } from '@/config/site'
import type { SeoMeta } from '@/lib/seo'

export const SeoHead = ({
  title,
  description,
  canonicalPath,
  image,
  type = 'website',
  noindex,
  fullSnippet,
  publishedTime,
  modifiedTime,
  jsonLd,
}: SeoMeta) => {
  const canonical = absoluteUrl(canonicalPath)
  const resolvedImage = absoluteUrl(image ?? siteConfig.ogImage)
  const isArticle = type === 'article'

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
      ) : fullSnippet ? (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      ) : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:site_name" content={siteConfig.name} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:image:width" content={String(siteConfig.ogImageWidth)} />
      <meta property="og:image:height" content={String(siteConfig.ogImageHeight)} />
      {isArticle && publishedTime ? <meta property="article:published_time" content={publishedTime} /> : null}
      {isArticle && modifiedTime ? <meta property="article:modified_time" content={modifiedTime} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={resolvedImage} />
      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
    </Helmet>
  )
}
